import { createContext, useContext } from "react";
import { MultiOrderItems } from "../types/items";
import { SelectedItem, SelectedItemsAction } from "./selectedItemsReducer";

type ItemsContextType = {
  items: MultiOrderItems | undefined;
  selectedItems: { [key: number]: SelectedItem };
  dispatch: (action: SelectedItemsAction) => void;
};

export const ItemsContext = createContext<ItemsContextType>({
  items: undefined,
  selectedItems: {},
  dispatch: () => {},
});

export const useSelectedItem = (index: number) => {
  const formContext = useContext(ItemsContext);
  return formContext?.selectedItems[index];
};
